// module factories are used so entry inlining is disabled
// startup
// Load entry module and return exports
var __webpack_exports__ = __webpack_require__.O(undefined, [1984,3821], () => (__webpack_require__(48072)))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
